import DBrokerDealerPage from './DBrokerDealerPage'

export default DBrokerDealerPage
